import React, { Component } from "react";

import Grid from "@mui/material/Grid";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import PageTitle from "components/PageTitle";
import PageDivider from "components/PageDivider";
import CheckList from "components/CheckList"

import MDInput from "components/MDInput";
import MDProgress from "components/MDProgress";
import LinearProgress from '@mui/material/LinearProgress';
import FileSystemGara from "./fileSystemGara.js"
import { toPrice, toPercentage, toEuropeanDate } from "helpers/functions"

import * as ajax from "helpers/ajax";

const inputStyle = {
    ".MuiOutlinedInput-root": {
        backgroundColor: "white!important",
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
    }
}

const progressBarStyle = {
    ".MuiLinearProgress-bar": {
        backgroundColor: "white!important",
    }
}



export default class DettaglioGara2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data || {},
            sal: 0,
            openFileSystem: false,
        };
    }

    componentDidMount = () => {
        this.calculateSal();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({ data: this.props.data || {} }, this.calculateSal);
        }
    }

    openFileSystem = (data) => {
        this.setState({ openFileSystem: true});
    }


    saveAdditionalData = (val, name) => {
        let data = {}
        data[name] = val

        let formData = { "data": data };
        ajax.ajaxPutStrapi("garas/" + this.state.data.id, formData, this.saveDataCallback)

        let temp = this.state.data
        temp[name] = val;
        this.setState({ data: temp })
    }

    saveDataCallback = (response) => {

    }

    checklistOnChange = (data) => {
        if (!this.state.data || !this.state.data.gara_checklists) {
            return;
        }
        let temp = this.state.data;
        let index=temp.gara_checklists.findIndex(x => x.id === data.id);
        temp.gara_checklists[index] = data;
        this.setState({data:temp}, this.calculateSal)
    }

    calculateSal = () => {
        if (!this.state.data || !this.state.data.gara_checklists) {
            return;
        }
        let total = this.state.data.gara_checklists.length;
        let percentage = 0;
        this.state.data.gara_checklists.map((el) => {
            if (el.completed) { percentage=percentage+(100/total)}
        })
        
        this.setState({ sal: percentage })
    }

    render() {
        if (this.state.openFileSystem) {
            return <FileSystemGara data={this.state.data} backFunction={() => this.setState({ openFileSystem: false })} />
        }
        
        if (!this.state.data) {
            console.warn("DettaglioGara: data is null/undefined");
            return null;
        }
        
        if (!this.state.data.gara_checklists || !Array.isArray(this.state.data.gara_checklists)) {
            console.warn("DettaglioGara: gara_checklists is missing or not an array", this.state.data.gara_checklists);
            return null;
        }

        // Create a sorted copy instead of mutating state
        const sortedChecklists = [...this.state.data.gara_checklists].sort(function (a, b) {
            return a.id - b.id;
        });

        let amount_subjcet_to_discount_C =this.state.data.base_amount-this.state.data.security
        let amount_discounted_E = amount_subjcet_to_discount_C * this.state.data.discount_percentage / 100
        let amount_proposed_F = amount_subjcet_to_discount_C - amount_discounted_E + this.state.data.security;

        //let markup_price = amount_proposed_F - (this.state.data.labor_cost + this.state.data.material_cost)
        let markup_price = amount_proposed_F - (this.state.data.costo_manodopera_preventivato + this.state.data.costo_ordini_preventivato)

        let markup_percentage = (markup_price * 100) / amount_proposed_F;

        return (
            <DashboardLayout>
                <DashboardNavbar />
                <PageTitle
                    text={this.state.data.name}
                    backButton={this.props.backFunction}
                />



                <PageDivider
                    text={"Dati Commessa"}
                />

                <Grid container>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={toEuropeanDate(this.state.data.start_date)}
                            variant="standard"
                            label={"Data Creazione"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={this.state.data.cig}
                            variant="standard"
                            label={"CIG"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={this.state.data.contract_type}
                            variant="standard"
                            label={"Tipologia di appalto"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={this.state.data.participant}
                            variant="standard"
                            label={"Partecipante"}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={toEuropeanDate(this.state.data.end_date)}
                            variant="standard"
                            label={"Data Consegna"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={this.state.data.cup}
                            variant="standard"
                            label={"CUP"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={toPrice(this.state.data.base_amount)}
                            variant="standard"
                            label={"Importo a base di gara"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} my={1} px={1}>
                        <MDInput
                            value={this.state.data.expected_days}
                            variant="standard"
                            label={"Giorni previsti da gantt a base di gara"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={1} my={1} px={1}>
                        <MDInput
                            value={this.state.data.days_type}
                            variant="standard"
                            label={" "}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={this.state.data.status}
                            variant="standard"
                            label={"Stato"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={this.state.data.category}
                            variant="standard"
                            label={"Categorie e classifiche"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={toPrice(this.state.data.security)}
                            variant="standard"
                            label={"Sicurezza"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={toPrice(this.state.data.labor_cost)}
                            variant="standard"
                            label={"Costi manodopera a base di gara"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={this.state.data.stazione_appaltante}
                            variant="standard"
                            label={"Stazione appaltante"}
                            fullWidth
                            disabled
                            multiline
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={1} my={1} px={1}>
                        <MDInput
                            value={this.state.data.accounting_type}
                            variant="standard"
                            label={"Tipo di contabilizzazione"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                     <Grid item xs={12} sm={12} md={2} my={1} px={1}>
                        <MDInput
                            value={this.state.data.award_type}
                            variant="standard"
                            label={"Tipologia di aggiudicazione"}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={toPrice(this.state.data.base_amount-this.state.data.security)}
                            variant="standard"
                            label={"Importo soggetto a ribasso"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} my={1} px={1}>
                        <MDInput
                            value={toPrice(this.state.data.material_cost)}
                            variant="standard"
                            label={"Costi stimati ordini base di gara"}
                            fullWidth
                            disabled
                        />
                    </Grid>


                </Grid >

                <PageDivider
                    text={"Dati offerta"}
                />

                <Grid container>
                    <Grid item xs={12} sm={12} md={6} my={1} px={1}>
                        <MDInput
                            value={toPercentage(this.state.data.discount_percentage)}
                            variant="standard"
                            label={"Ribasso %"}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} my={1} px={1}>
                        <MDInput
                            value={toPrice(amount_discounted_E)}
                            variant="standard"
                            label={"Ribasso in euro"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} my={1} px={1}>
                        <MDInput
                            value={toPercentage(markup_percentage)}
                            variant="standard"
                            label={"markup preventivato in %"}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} my={1} px={1}>
                        <MDInput
                            value={toPrice(markup_price)}
                            variant="standard"
                            label={"markup preventivato in €"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} my={1} px={1}>
                        <MDInput
                            value={toPrice(amount_proposed_F)}
                            variant="standard"
                            label={"Importo proposto"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} my={1} px={1}>
                        <MDInput
                            value={this.state.data.durata_offerta + "gg " + this.state.data.days_type}
                            variant="standard"
                            label={"Durata"}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} my={1} px={1}>
                        <MDInput
                            value={toPrice(this.state.data.costo_manodopera_preventivato)}
                            variant="standard"
                            label={"Costo manodopera preventivato"}
                            fullWidth
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} my={1} px={1}>
                        <MDInput
                            value={toPrice(this.state.data.costo_ordini_preventivato)}
                            variant="standard"
                            label={"Costo ordini preventivato"}
                            fullWidth
                            disabled
                        />
                    </Grid>

                </Grid >


                {/*
                 
                         let amount_subjcet_to_discount_C =this.state.data.base_amount-this.state.data.security
        let amount_discounted_E = amount_subjcet_to_discount_C * this.state.data.discount_percentage / 100
        let amount_proposed_F = amount_subjcet_to_discount_C - amount_discounted_E + this.state.data.security;
        let markup_price = amount_proposed_F - (amount_discounted_E+this.state.data.material_cost)
        let markup_percentage =0;

                 */}
                <PageDivider
                    text={"Stato avanzamento"}
                />
                <MDProgress sx={{ backgroundColor: "white!important", marginBottom: 5 }} value={this.state.sal} variant="gradient" color={(this.state.sal >= 100) ? "success" : "info"} label />


                {sortedChecklists.map((el, index) => {
                    return (
                        <CheckList
                            key={"checklist-" + index}
                            data={el}
                            onChange={(data) => this.checklistOnChange(data)}
                            id={this.state.data.id}
                            openFileSystem={() => this.openFileSystem()}
                            subfolder={el.name}
                        />
                    )
                })}

            </DashboardLayout>
        )
    }
}


